module.exports = __webpack_public_path__ + "img/cool@2x.2f7e68d.jpg";